import { ref } from "vue";
import i18next from "@/i18n";
import { apiService } from "@/services/apiService";

export function useSystemSettings() {
    const translate = (key) => i18next.t(key);

    const canReadSystemSettings = ref(true);

    const loading = ref(false);
    const error = ref(null);

    const fetchSystemSettings = async () => {
        if (!canReadSystemSettings.value) {
            error.value = translate("crudMessages.readDenied", {
                resource: "systemSettings",
            });
            return [];
        }
        loading.value = true;
        try {
            return await apiService.get("/settings/");
        } catch (err) {
            error.value = 
                err?.detail ||
                err?.message ||
                translate("crudMessages.fetchError", { resource: "categories" });
            return null;
        } finally {
            loading.value = false;
        }
    };

    return {
        fetchSystemSettings,
        loading,
    }
}